import React, { useState } from "react";
import { toast } from "sonner";
import { BellRing, Loader2, CheckCircle2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

export default function NotifyMe({ productId }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Please enter your email");
    setLoading(true);
    try {
      const { data } = await api.post(`/products/${productId}/notify-me`, { email: email.trim() });
      setDone(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="mt-8 border border-primary/30 bg-secondary/40 p-5 flex items-start gap-3" data-testid="notify-me-done">
        <CheckCircle2 size={20} className="text-primary shrink-0 mt-0.5" />
        <p className="text-sm text-foreground/80">
          You're on the list! We'll email you the moment this is back in stock.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-8 border border-border bg-secondary/30 p-5" data-testid="notify-me-box">
      <p className="flex items-center gap-2 text-sm font-semibold text-foreground">
        <BellRing size={16} className="text-accent" /> Currently out of stock
      </p>
      <p className="mt-1 text-sm text-muted-foreground">
        Leave your email and we'll ping you when it's back.
      </p>
      <form onSubmit={submit} className="mt-3 flex gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 bg-muted px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-primary"
          data-testid="notify-me-email"
        />
        <button
          type="submit"
          disabled={loading}
          className="bg-primary text-primary-foreground px-5 py-2.5 text-sm flex items-center gap-2 disabled:opacity-60"
          data-testid="notify-me-submit"
        >
          {loading && <Loader2 size={14} className="animate-spin" />} Notify Me
        </button>
      </form>
    </div>
  );
}
